var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// Utils
import styled from 'styled-components';
/**
 * @deprecated Do not use legacy components anymore.
 */
export var Button = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  display: ", ";\n  border: ", ";\n  border-radius: ", ";\n  padding: ", ";\n  justify-content: ", ";\n  background-color: ", ";\n"], ["\n  width: ", ";\n  height: ", ";\n  display: ", ";\n  border: ", ";\n  border-radius: ", ";\n  padding: ", ";\n  justify-content: ", ";\n  background-color: ", ";\n"])), function (_a) {
    var width = _a.width;
    return (width ? "".concat(width) : '131px');
}, function (_a) {
    var height = _a.height;
    return (height ? "".concat(height) : '32px');
}, function (_a) {
    var display = _a.display;
    return (display ? "".concat(display) : 'block');
}, function (_a) {
    var border = _a.border;
    return (border ? "".concat(border) : '1px solid #fff');
}, function (_a) {
    var borderRadius = _a.borderRadius;
    return (borderRadius ? "".concat(borderRadius) : '4px');
}, function (_a) {
    var padding = _a.padding;
    return (padding ? "".concat(padding) : '8px');
}, function (_a) {
    var justifyContent = _a.justifyContent;
    return (justifyContent ? "".concat(justifyContent) : 'center');
}, function (_a) {
    var backgroundColor = _a.backgroundColor;
    return (backgroundColor ? "".concat(backgroundColor) : null);
});
var templateObject_1;
//# sourceMappingURL=Button.js.map